module.exports = __webpack_public_path__ + "img/invoices.8488e412.svg";